

























































import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  props: {
    source: String
  },
  data: () => ({
    drawer: null
  }),

  computed: mapGetters("auth", ["isAuthenticated"])
});
